var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgError)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.supplier))])]):_c('div',[_c('img',{staticClass:"h-6",attrs:{"src":_vm.supplierLogoPath,"alt":_vm.supplier}})])
}
var staticRenderFns = []

export { render, staticRenderFns }